let count = 0;

export function lockScroll() {
  count++;
  if (count === 1) {
    const scrollY = window.scrollY;
    document.documentElement.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
  }
}

export function unlockScroll() {
  count = Math.max(0, count - 1);
  if (count === 0) {
    const top = Math.abs(parseInt(document.body.style.top || "0", 10));
    document.documentElement.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    window.scrollTo(0, top);
  }
}
